import { appTranslation } from "./Translation";
import store from "../redux/store";
import { setLang } from "../redux/actions";

export const setTranslations = async (lang = null) => {
  try {
    const selectedLang = lang || localStorage.getItem("lang") || "en";

    // Fetch translations from cache or API
    let trns = JSON.parse(localStorage.getItem("Trans")) || {};
    // console.log("trns",trns);
    // If cache is empty, fetch all translations
    // if (!Object.keys(trns).length) {
      trns = await appTranslation(); // must return { key: { en: "...", jp: "..." } }
      if (trns) localStorage.setItem("Trans", JSON.stringify(trns));
    // }

    // Map translations for the selected language
    const obj = {};
    Object.keys(trns).forEach((key) => {
      obj[key] = trns[key][selectedLang] || trns[key]["en"]; // fallback to English
    });

    // console.log("Translations for", selectedLang, obj);

    localStorage.setItem("lang", selectedLang);
    store.dispatch(setLang(obj));
  } catch (error) {
    console.error("setTranslations error:", error);
  }
};
